
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 6L5.667 3.667 8 1.333l2.333 2.334L8 6zM.667 13.333v-2.666c0-.378.13-.695.391-.95.261-.256.575-.384.942-.384h2.183c.223 0 .434.056.634.167.2.111.36.261.483.45.322.433.72.772 1.192 1.017.472.244.975.366 1.508.366a3.27 3.27 0 001.525-.366A3.29 3.29 0 0010.7 9.95c.144-.189.314-.339.508-.45.195-.111.397-.167.609-.167H14c.378 0 .694.128.95.384.256.255.383.572.383.95v2.666h-4.666v-1.516a4.541 4.541 0 01-4.067.625 4.69 4.69 0 01-1.267-.642v1.533H.667zm2-4.666a1.929 1.929 0 01-1.417-.584 1.929 1.929 0 01-.583-1.416c0-.567.194-1.042.583-1.425a1.943 1.943 0 011.417-.575c.566 0 1.041.191 1.425.575.383.383.575.858.575 1.425 0 .555-.192 1.027-.575 1.416-.384.39-.859.584-1.425.584zm10.666 0a1.929 1.929 0 01-1.416-.584 1.929 1.929 0 01-.584-1.416c0-.567.195-1.042.584-1.425a1.943 1.943 0 011.416-.575c.567 0 1.042.191 1.425.575.384.383.575.858.575 1.425 0 .555-.191 1.027-.575 1.416-.383.39-.858.584-1.425.584z","fill":"currentColor"}})])
          )
        }
      }
    